import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const SIZES = ['xxs', 'xs', 's', 'm', 'l', 'xl'];

/**
 * Wrapper with different sizes, so far just desktop size is available
 */
export default function ContentWrap({ children, isElastic, size, className }) {
  return (
    <div
      className={cx({ [size[0]]: SIZES.indexOf(size[0]) !== -1, elastic: isElastic }, className)}
    >
      <div className={cx('content')}>{children}</div>
    </div>
  );
}

ContentWrap.propTypes = {
  children: PropTypes.node,
  isElastic: PropTypes.bool, // when set to true, wide content will stretch container all the way to 100%
  size: PropTypes.arrayOf(PropTypes.oneOf([null, ...SIZES])),
  className: PropTypes.string,
};

ContentWrap.defaultProps = {
  size: ['l'],
};
